import { useEffect } from 'react';
import { useAxios } from 'src/hooks/use-axios';
import { NotFound } from 'src/utils/errors';

export function useLookup<T>(url: string) {
  const lookup = useAxios(
    (axios, signal) =>
      axios.request<T[]>({
        signal,
        url: `${PRISMA_CONFIG.remitReporting}/api/platform/lookup/${url}`,
        method: 'GET',
      }),
    {
      neededOnPageLoad: true,
      cacheKey: `remit-lookup-${url}`,
    }
  );

  useEffect(() => {
    if (PRISMA_CONFIG.remitReporting == null) return;
    lookup.execute();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (PRISMA_CONFIG.remitReporting == null) throw new NotFound();

  return lookup;
}
